import { useEffect } from 'react';

const useScript = (url, body, async) => {
  useEffect(() => {
    if (url || body) {
      const script = document.createElement('script');

      script.async = true;

      if (url) script.src = url;
      if (body) script.innerHTML = body;
      if (!async) script.async = false;

      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      }
    }
  }, [url, body, async]);
};

export default useScript;